module.exports = __webpack_public_path__ + "img/Group 427319324.d2374b04.png";